<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Riwayat PLT
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Riwayat PLT</h5>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          id="gridContainer"
          ref="gridRef"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="ID"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          :filter-value="filterValue"
          :filter-sync-enabled="true"
          @exporting="onExporting"
        >
          <DxToolbar>
            <!-- <DxItem name="groupPanel" /> -->
            <DxItem location="after" template="refresh-template" />
            <!-- <DxItem name="addRowButton" show-text="always" /> -->
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <!-- <DxItem name="searchPanel" /> -->
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <DxHeaderFilter :visible="true" />

          <DxFilterRow :visible="true" :apply-filter="currentFilter" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="10" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />

          <DxColumn
            caption="#"
            data-field="pegawai_id"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-hiding="false"
            :fixed="true"
            fixed-position="left"
          />

          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>

          <dx-column
            data-field="status"
            caption="Status"
            :dataType="'boolean'"
            cell-template="templateStatus"
            :fixed="true"
            fixed-position="left"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="statusSource"
            />
          </dx-column>
          <template #templateStatus="{ data }">
            <StatusTemplate :value="data.value" />
          </template>

          <DxColumn
            data-field="simpegPegawai.nama"
            caption="Pegawai"
            :allow-hiding="false"
            :fixed="true"
            fixed-position="left"
          >
          </DxColumn>
          <DxColumn
            data-field="simpegPegawai.nik"
            caption="NIK"
            :allow-hiding="false"
            :fixed="true"
            fixed-position="left"
          >
          </DxColumn>

          <DxColumn caption="Jabatan Definitif">
            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].jabatan_id"
              caption="Jabatan"
            >
              <DxLookup
                :data-source="jabatanSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].cabang_id"
              caption="Cabang"
            >
              <DxLookup
                :data-source="cabangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].unit_id"
              caption="Unit"
            >
              <DxLookup
                :data-source="unitSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].bagian_id"
              caption="Bagian"
            >
              <DxLookup
                :data-source="bagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].sub_bagian_id"
              caption="Sub Bagian"
            >
              <DxLookup
                :data-source="subBagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].bidang_id"
              caption="Bidang"
            >
              <DxLookup
                :data-source="bidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].sub_bidang_id"
              caption="Sub Bidang"
            >
              <DxLookup
                :data-source="subBidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].seksi_id"
              caption="Seksi"
            >
              <DxLookup
                :data-source="seksiSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
          </DxColumn>

          <DxColumn caption="Jabatan PLT" css-class="header-highlighted">
            <DxColumn
              data-field="jabatan_id"
              caption="Jabatan PLT"
              css-class="cell-highlighted"
            >
              <DxLookup
                :data-source="jabatanSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              data-field="cabang_id"
              caption="Cabang PLT"
              css-class="cell-highlighted"
            >
              <DxLookup
                :data-source="cabangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              data-field="unit_id"
              caption="Unit PLT"
              css-class="cell-highlighted"
            >
              <DxLookup
                :data-source="unitSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              data-field="bagian_id"
              caption="Bagian PLT"
              css-class="cell-highlighted"
            >
              <DxLookup
                :data-source="bagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              data-field="sub_bagian_id"
              caption="Sub Bagian PLT"
              css-class="cell-highlighted"
            >
              <DxLookup
                :data-source="subBagianSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].bidang_id"
              caption="Bidang PLT"
              css-class="cell-highlighted"
            >
              <DxLookup
                :data-source="bidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].sub_bidang_id"
              css-class="cell-highlighted"
              caption="Sub Bidang PLT"
            >
              <DxLookup
                :data-source="subBidangSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>

            <DxColumn
              data-field="simpegPegawai.riwayatPekerjaans[0].seksi_id"
              css-class="cell-highlighted"
              caption="Seksi PLT"
            >
              <DxLookup
                :data-source="seksiSource"
                value-expr="id"
                display-expr="nama"
              />
            </DxColumn>
          </DxColumn>
          <template #printJabatanDefinitifTemplate="{ data }">
            {{ printJabatanDefinitif(data) }}
          </template>

          <!-- <DxColumn
            data-field="tgl"
            caption="Tgl"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :calculate-filter-expression="calculateFilterExpression"
            :filter-operations="filterOperations"
            sort-order="asc"
          /> -->
          <!-- <DxColumn data-field="golongan_id" caption="Golongan">
            <DxLookup
              :data-source="golonganSource"
              value-expr="id"
              display-expr="nama"
            />
          </DxColumn> -->
          <!-- <dx-column
            data-field="capeg"
            caption="Capeg"
            cell-template="capegTemplate"
          >
          </dx-column>

          <template #capegTemplate="{ data }">
            {{ formatCapeg(data) }}
          </template> -->

          <!-- <DxColumn data-field="ket" caption="Ket." />
          <DxColumn data-field="status" caption="Status">
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="statusSource"
            />
          </DxColumn> -->

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
            :allow-hiding="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
          <DxColumnChooser :enabled="true" :mode="mode">
            <DxPosition
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <DxColumnChooserSearch
              :enabled="true"
              :editor-options="editorOptions"
            />
            <DxColumnChooserSelection
              :allow-select-all="allowSelectAll"
              :select-by-click="selectByClick"
              :recursive="recursive"
            />
          </DxColumnChooser>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import { ODATA_BASE_URL } from "@/global-constants";
// import "devextreme/dist/css/dx.light.css";
import _ from "lodash";
import DxButton from "devextreme-vue/button";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import router from "@/router";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnChooser,
  DxColumnChooserSearch,
  DxColumnChooserSelection,
  DxPosition,
  DxColumnFixing,
  DxHeaderFilter,
  DxToolbar,
  DxItem,
  DxExport,
} from "devextreme-vue/data-grid";

import { useBagianStore } from "@/stores/BagianStore";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";

import StatusTemplate from "./StatusTemplate.vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
function getUrlFilter() {
  return router.currentRoute.value.query.filter;
}
const options = ["Detail"];

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "simpegPegawai/")
  );
}

function convertFilter(filter, regVar) {
  console.log("filter", filter);
  //FIXME: HANYA UNTUK RIWAYAT GOLONGAN N RIWAYAT PEKERJAAN YG ADA STATUS EQ 1

  // const regex = /riwayatGolongans\[\d+\]\/(\w+) eq (\d+)/;
  // const regex = new RegExp(`${regVar}\\[\\d+\\]\/(\\w+) eq (\\d+)`, "g");
  const regex = new RegExp(`${regVar}\\[\\d+\\]/(\\w+) eq (\\d+)`, "g");

  console.log("regex", regex);
  // const outputString = filter.replace(
  //   regex,
  //   "riwayatGolongans/any(s:s/$1 eq $2)"
  // );
  // const outputString = filter.replace(regex, `${regVar}/any(s:s/$1 eq $2)`);
  const outputString = filter.replace(regex, (match, p1, p2) => {
    return `${regVar}/any(s:s/${p1} eq ${p2} and s/status eq 1)`;
  });

  console.log("convert", outputString);
  return outputString;
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(simpegPegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(simpegPegawai\/nama\),'([^']+)'/,
    `simpegPegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(simpegPegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(simpegPegawai\/nik\),'([^']+)'/,
    `simpegPegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxDropDownButton,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxColumnChooserSelection,
    DxPosition,
    StatusTemplate,
    DxColumnFixing,
    DxHeaderFilter,
    DxButton,
    DxToolbar,
    DxItem,
    DxExport,
  },
  setup() {
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();
    const jabatanStore = useJabatanStore();
    return {
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
      cabangStore,
      unitStore,
      jabatanStore,
    };
  },
  data() {
    return {
      filterValue: null,
      // filterValue: [["status", "=", 1]],
      mode: "select",
      searchEnabled: true,
      allowSelectAll: true,
      selectByClick: true,
      recursive: true,
      editorOptions: { placeholder: "Search column" },
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],
      numberingPageSize: 10,
      numberingPageNumber: 0,

      router: router,
      options: options,
      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/SimpegPegawais",
      //   key: "id",
      // }),

      bagianSource: null,
      bidangSource: null,
      subBagianSource: null,
      subBidangSource: null,
      seksiSource: null,
      cabangSource: null,
      unitSource: null,
      jabatanSource: null,

      dataSource: null,
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">", "<", "between"],

      oneditorpreparing: function (e) {
        console.log(e);
        if (e.dataField === "tgl") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
    };
  },
  async mounted() {
    console.log(this.$refs.gridRef.instance);
    console.log(this.$refs.gridRef.instance.pageCount());
    console.log(this.$refs.gridRef.instance.pageIndex());
    console.log(this.$refs.gridRef.instance.pageSize());
    this.dataSource = this.fetchData();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();
    this.jabatanSource = await this.jabatanStore.get();
  },
  methods: {
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Riwayat PLT.xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    fetchData() {
      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/RiwayatPlts`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
            if (typeof e.params.$filter == "undefined") {
              console.log("undefined");
              // e.params.$filter = "month(tgl) eq '5' and year(tgl) eq '2023'";
              e.params.$filter = getUrlFilter();
            }
            if (hasFilterNestedTable(e.params.$filter)) {
              console.log("hasFilterNestedTable");
              e.params.$filter = convertFilterPegawai(e.params.$filter);
              e.params.$filter = convertFilter(
                e.params.$filter,
                "simpegPegawai/riwayatPekerjaans"
              );
            }
          },
        }),
        // filter: [["status", 1]], -->otomatis filter plt aktif
        expand: [
          "simpegPegawai($expand=riwayatPekerjaans($filter=status eq 1))", //pekerjaan definitif yang sedang aktif
        ],
      });
      // const data = await odataStore.load({});
      // return data;
      return odataStore;
    },

    //     fetchData dataSource = new DataSource({
    //   store: new ODataStore({
    //     // ODataStore is configured here
    //     url: "http://127.0.0.1/odata/RiwayatPlts",
    //     key: "id",
    //     version: 4,
    //     beforeSend: function (e) {
    //       e.headers = {
    //         "odata-version": "4.0",
    //       };
    //       console.log(e);

    //       if (typeof e.params.$filter == "undefined") {
    //         console.log("undefined");
    //         // e.params.$filter = "month(tgl) eq '5' and year(tgl) eq '2023'";
    //         e.params.$filter = getUrlFilter();
    //       }
    //       if (hasFilterNestedTable(e.params.$filter)) {
    //         console.log("hasFilterNestedTable");
    //         e.params.$filter = convertFilterPegawai(e.params.$filter);
    //         e.params.$filter = convertFilter(
    //           e.params.$filter,
    //           "simpegPegawai/riwayatPekerjaans"
    //         );
    //       }
    //     },
    //   }),
    //   filter: [["status", 1]],
    //   expand: ["simpegPegawai($expand=riwayatPekerjaans($filter=status eq 1))"],
    // });

    printJabatanDefinitif(data) {
      console.log("PRINTJABATANDEFINITIF");
      console.log(data);
    },
    formatCapeg(data) {
      if (data.value) {
        return "80%";
      }
    },
    onPageChanged(e) {
      console.log("onpagechanged");
      console.log(e);
      if (e.fullName == "paging.pageIndex") {
        console.log("===========UBAH PAGING============");

        console.log("halaman " + e.value);
        console.log("jumlahrow " + this.$refs.gridRef.instance.pageSize());
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onItemClick(e) {
      let pegawaiId = e.element.id;
      console.log("ONTITEMCLICK", e);

      // this.router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: pegawaiId },
      // });
      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: pegawaiId },
      }).href;
      window.open(url, "_blank");
    },
    cobaTemplate(data) {
      console.log(data);

      return `<div>${data.rowIndex + 1}</div>`;
    },

    numberingTemplate2(cellElement, cellInfo) {
      // cellElement, cellInfo
      // console.log("NUMBER");
      // console.log("element");
      // console.log(cellElement);
      // console.log("rownumber " + cellInfo.rowIndex);
      // cellInfo.values[0] = "1";
      // cellInfo.text = "1";
      // cellInfo.value = "1";
      console.log(cellInfo);
    },
  },
};
</script>

<style>
.header-highlighted {
  /* background-color: #e6e6e6; */
  /* background-color: #f1e740; */
  background-color: #ffdfd3;
  color: black;
  /* color: black; */
}

.dx-data-row .cell-highlighted {
  /* background-color: #e6e6e6; */
  /* background-color: #f1e740; */
  background-color: #ffdfd3;
  color: black;
  /* color: black; */
}

.dx-header-row .cell-highlighted {
  color: black;
  /* background-color: #e6e6e6; */
  /* background-color: #f1e740; */
  background-color: #ffdfd3;
}
</style>
